export const WHITE = '#FFF'
export const PRIMARY = '#151515'
export const LIGHT_GREY = '#f3f3f3'
